module.exports = __webpack_public_path__ + "static/media/image_10.ad70fb5d.png";